export default __webpack_public_path__ + "static/media/marseille-1x.277fa48c.webp";